var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{attrs:{"url":"payments","columns":_vm.columns,"title":_vm.title,"expandedOptions":{
        enabled: true,
        allowExpandingAll: true,
        template: 'payment-details',
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }